import {
    LOAD_VIEW3,
    LOAD_VIEW3_SUCCESS,
    SAVE_VIEW3
} from "../constants";

export const loadView3 = ({url,queryParams}) => {
    return {
        type: LOAD_VIEW3,
        url,
        queryParams
    };
};


export const saveView3 = ({id,key,value, data}) => {
    return {
        type: SAVE_VIEW3,
        id,
        key,
        value,
        data
    };
};




export const loadView3Success = ({nodes,rootId,templateId,effects}) => {
    return {
        type: LOAD_VIEW3_SUCCESS,
        nodes,
        rootId,
        templateId,
        effects
    };
};

